module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 1")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("“T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HIS IS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("R")]), _vm._v(". V"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IDAS")]), _vm._v(",”")]), _vm._v(" explained Diego’s court-appointed attorney as they headed into juvenile court. “He’s the probation officer assigned to your case.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The stocky thirtysomething PO was shorter than six-foot-one Diego, but his grip was that of someone sure of himself, his voice calm and confident. “Good to meet you, Diego.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego shook hands warily. What would Vidas want from him? What if he decided he didn’t like Diego? Would he recommend that the judge lock him up in juvie?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The courtroom looked like the set of some law drama—except for Diego this wasn’t TV but real life. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("His")]), _vm._v(" life, spinning from bad to worse. He’d let himself down. Big-time.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("He slid his lanky frame awkwardly into the defendant’s chair, aware of the faint smell of his own nervous sweat. He wished he could change the channel and be at home, taking care of his aquarium fish or goofing around with his little brother, Eddie; ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("or at the beach with his best friend, Kenny, hunting for shells and riding waves; or at school, watching Ariel across the hall, hoping she might look over at him. He wished he could be anywhere else in the world but here.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("As the bailiff announced the case, Diego’s outgrown dress shoes chewed at his ankles. His crimson-colored tie felt like a noose around his neck. And from beside the brightly polished judge’s bench, Vidas’s hazel eyes peered directly at Diego—as if trying to see inside him, figure him out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego glanced away, trying to act casual as he slid his hands beneath the defense table, where he tugged the cuffs of his long-sleeve shirt down to make sure they covered the cuts above his wrists.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Judge Ferrara, flanked by the American and Texas flags, gazed up from the file he was reading and peered over the front of the podium. “Your name’s Diego MacMann? What is that? Mexican-Irish?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego sat up, caught off guard. Wasn’t the judge supposed to address the lawyers? Ms. Delgado, his attorney, nodded for him to respond. Little sweat blisters burst onto his forehead as he replied, “Um, yes sir, your honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At seven years old, he’d moved from Puerto Vallarta, on Mexico’s Pacific coast, to Corpus Christi when his mom married his stepdad, James MacMann. In the process, “Mac” had adopted him. Nobody had asked Diego what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" wanted.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("“Well, that’s interesting,” the judge mused. The lenses of his horn-rimmed glasses made his eyes look huge and round as an owl’s. “Sixteen years old…” He continued to read the ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("file aloud. “…first time misdemeanor assault…”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The incident had happened at school, in the hallway outside the cafeteria on the way to lunch. Fabio Flores, a junior who painted his fingernails purple, wore eye makeup, and told the entire school he was gay, kept grinning at Diego.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It pissed Diego off. Why the hell did Fabio keep looking at him that way? Diego told him to stop, but Fabio kept it up until Diego couldn’t stand it anymore. The anger moved like a pair of hands across his body.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He popped Fabio in the face—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only")]), _vm._v(" one punch and not even that hard—expecting Fabio to block him. Or run away. Or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v(". He’d clearly seen Diego’s punch coming. Why’d he just stand there?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His nose spurted like a fire hydrant, gushing blood all over the hall tiles. Girls screamed. The hallway monitors pinned Diego to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He knew he shouldn’t have hit Fabio. He’d never wanted to hurt anybody. But even though he said he hadn’t meant it, the vice principal suspended him for a week. And Fabio’s dad had pressed charges.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“So does this mean,” Judge Ferrara continued speaking directly to Diego, his voice turning angry, “that you’ve got an Irish temper or a Latin temper? Or both?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Um, I don’t know.” Diego stumbled over a response, as a bead of sweat trickled down his forehead. “Your honor, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, whichever it is”—Judge Ferrara jabbed his finger toward Diego—“you’d better learn to control that temper or I’ll put you in jail. You understand that?”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Um, yes,” Diego replied, his voice trembling.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what")]), _vm._v("?” the judge demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, I understand, your honor, sir.” Diego’s heart pounded fearfully.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Judge Ferrara glared at him a long moment, then shifted his gaze to the prosecutor. “How do you wish to proceed with this case?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While the prosecutor related the plea bargain, Diego only half-listened, rattled by his fears of being jailed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before court, Ms. Delgado had explained to his mom and him the plea deal:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If you plead "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" guilty and a trial proves you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" guilty, the prosecutor will demand jail time. But if you plead guilty and forego trial, the prosecution will usually support whatever sentence your PO recommends. Most likely you’ll get probation. Maybe even less than that. It’s your decision, but if I were you, I’d take the plea deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With his mom’s agreement, Diego had said yes to the plea bargain. Anything to avoid jail.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Judge Ferrara now accepted the plea, ordered a presentencing investigation, and set a disposition date. Next thing Diego knew, he was back in the waiting room with his attorney, his mom, and Vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Now, you do whatever Mr. Vidas says,” Ms. Delgado told Diego. “Okay? I’ll see you on your sentencing date.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She said good-bye to everybody, and Diego’s mom immediately turned to Vidas. “I want him to be on probation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Ma!” Diego protested. “I don’t need probation. I’m fine!”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“If you’re fine, why are we here?” She spoke to him as though he were a kid, despite the fact that he stood taller than her—even when she wore heels, like now. “I try to talk to him,” she told Vidas, “but he won’t listen to me. I don’t know what to do with him anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re the one who never listens,” Diego muttered. He figured Vidas would take his mom’s side like other adults normally did. But Vidas didn’t. Apparently he was used to hearing such arguments.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hold on.” He calmly raised his palms up between Diego and his mom, referee-like. “Let me explain what happens next. For the presentence investigation, I’ll need to conduct a home visit, get your school records, interview the victim, and hear your side of the incident. Based on what I find out, I’ll recommend a sentence to the judge. It might be probation or something else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But not juvie, right?” Diego’s voice rose, tight and tense.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Probably not,” Vidas said. Once again he peered into Diego’s eyes as if trying to glimpse things that Diego didn’t want him—or anybody—to see.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“But it’s too soon for me to rule anything out,” Vidas continued. “A lot will depend on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego looked away. Why couldn’t Vidas just assure him he wouldn’t end up in jail?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How is he behaving at home?” Vidas asked his mom.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Most of the time he’s a good boy. He takes care of his brother in the evenings and makes their dinner, he does his chores and homework….”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Hearing her praise, Diego relaxed a little—until she added, “But sometimes his anger just explodes! I’ve told him he needs to control his emotions.” She turned to Diego. “Why won’t you listen to me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why don’t you listen to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v("?” Diego shot back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And his father?” Vidas asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“His stepfather died,” his mom said softly, “three years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego glanced down at the floor, not wanting to think about Mac’s suicide, wishing he could just forget Mac altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m very sorry to hear that,” Vidas told his mom. Then he pulled an electronic planner from his herringbone jacket. “What’s the best day for a home visit?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I have to work two jobs,” his mom explained. “I only have Sundays off.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Unfortunately,” Vidas replied, “the visit needs to be during office hours, Monday through Friday, eight-thirty to five-thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mom glared at Diego and shook her head so angrily that the chrome clip fell out of her hair. “I can’t keep taking time off because of your fights! You’re going to make me lose my job!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Feeling a little guilty, Diego stooped down and picked up the clip. He knew his mom was struggling to keep their family afloat. There hadn’t been any life insurance settlement because Mac’s death was a suicide. But even when Diego tried to help his mom with money from his Saturday job, she told him to save it for college.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("As he handed her the clip her gaze softened. “Thursday, I guess,” she told Vidas. “Can you please make it later in the afternoon so I don’t have to take the whole day off?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sure. No problem. How about four o’clock?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay, thank you. I hope you can help Diego. Maybe he’ll listen to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Let’s see what we can do,” Vidas said optimistically. He shook her hand good-bye and turned to Diego, grasping his palm as though squaring some deal. Once again he looked him in the eyes, as if searching for something.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego tried to not look away, although he wished Vidas would stop doing that.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Outside the courthouse, Diego tore away the strangling necktie, a gift from Mac his mom had made him wear. Inside their old Toyota, he cast off the cramped dress shoes and changed into his well-worn sneakers, grumbling, “Why’d you have to tell him to put me on probation?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mom ignored the question and phoned the nursing home where she worked. Although she told them she was on her way, when she pulled out of the garage, she glanced at the clock and asked Diego, “Isn’t it after your lunch period? We’d better stop to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I thought you had to get to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yes, but you have to eat.” His mom "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("always")]), _vm._v(" made sure he ate.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They stopped at a fish-and-chips place across from the seawall overlooking the bay. Inside the restaurant, he noticed that the Value Meal included a mini spyglass telescope. He decided to get one for his friend, Kenny, just for fun.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sitting down at a booth, Diego’s mom bit into a fried shrimp and commented, “Mr. Vidas seems like a very nice man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You don’t even know him yet,” Diego protested. She was always too trusting of people. “How do you know he’s not some serial killer?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ay")]), _vm._v(", you’re being silly.” His mom pressed a napkin to her lips. “You need a man to talk to—a father figure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You don’t know what I need,” Diego fired back, recalling his previous so-called father figure, Mac. “You’ve got no idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nobody but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" knew the truth about Mac. His mom had never wanted to know, even when Diego tried to tell her. Now it was too late; it was over. Mac was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Turning away from his mom, Diego lifted the tiny spyglass to his eye. He stared out the window toward the dark green waters of the bay, thinking—and wanting to forget.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0fea7bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416995050_ch01.vue
// module id = 81
// module chunks = 0